(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maligo-home"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__mhInit) return; window.__mhInit = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Startvideo: bei „Bewegung reduzieren“ nur Standbild
  document.querySelectorAll('.mh-hero__video').forEach((v) => { if (reduce) { v.removeAttribute('autoplay'); v.pause(); } });

  // feste „Jetzt gestalten“-Leiste am Handy, sobald das Startbild weg ist (nicht über dem Fußbereich)
  const hero = document.querySelector('[data-mh-hero]'), sticky = document.querySelector('[data-mh-sticky]');
  if (hero && sticky && 'IntersectionObserver' in window) {
    let past = false, nearEnd = false;
    const set = () => sticky.classList.toggle('is-on', past && !nearEnd);
    new IntersectionObserver(([e]) => { past = !e.isIntersecting && e.boundingClientRect.top < 0; set(); }).observe(hero);
    const foot = document.querySelector('footer, .shopify-section-group-footer-group');
    if (foot) new IntersectionObserver(([e]) => { nearEnd = e.isIntersecting; set(); }).observe(foot);
  }

  // sanftes Einblenden der Blöcke
  if (!reduce && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.mh-block').forEach((el) => { el.classList.add('mh-reveal'); io.observe(el); });
  }

  // Rechner (19.10.2026): Gewinn pro Bestellung (Bundle) statt pro Monat
  document.querySelectorAll('[data-mh-calc]').forEach((box) => {
    let tiers; try { tiers = JSON.parse(box.dataset.tiers); } catch (e) { return; }
    const lang = (box.dataset.lang || 'de').toLowerCase();
    const loc = lang === 'en' ? 'en-IE' : lang === 'de' ? 'de-DE' : lang;
    const fmt = (n) => new Intl.NumberFormat(loc, { style: 'currency', currency: 'EUR', maximumFractionDigits: Math.abs(n) >= 1000 ? 0 : 2 }).format(n);
    const inp = box.querySelector('.mh-calc__in'); const tx = inp.dataset;
    const fill = (s, o) => String(s).replace(/\{(\w+)\}/g, (m, k) => (k in o ? o[k] : m));
    const TRAY = { J30: 24, B30: 27 }, KIT = { J30: 72, B30: 81 };
    let prod = 'J30', idx = 2;
    const qty = box.querySelector('[data-mh-qty]'), price = box.querySelector('[data-mh-price]'), go = box.querySelector('[data-mh-calc-go]');
    const list = () => (tiers[prod] || []).filter((x) => Array.isArray(x) && x[0] > 0).sort((a, b) => a[0] - b[0]);
    const chips = () => {
      qty.innerHTML = list().map((x, i) => { const n = Math.round(x[0] / TRAY[prod]); return `<button type="button" data-i="${i}" class="${i === idx ? 'is-on' : ''}${x[0] >= KIT[prod] ? ' is-kit' : ''}">${n} ${n === 1 ? tx.tTray : tx.tTrays}<small>${x[0]} ${tx.tCans}</small></button>`; }).join('');
      qty.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => { idx = +b.dataset.i; chips(); calc(); }));
    };
    const calc = () => {
      const l = list(); if (!l.length) return;
      if (idx >= l.length) idx = l.length - 1;
      const [units, cents] = l[idx];
      const cost = cents / 100;
      const sell = Math.max(0, parseFloat(String(price.value).replace(',', '.')) || 0);
      const rev = sell * units, profit = rev - cost;
      box.querySelector('[data-mh-buy]').textContent = fmt(cost);
      box.querySelector('[data-mh-revl]').textContent = fill(tx.tRev, { p: fmt(sell) });
      box.querySelector('[data-mh-rev]').textContent = fmt(rev);
      box.querySelector('[data-mh-profit]').textContent = fmt(profit);
      const pc = rev > 0 ? Math.min(100, (cost / rev) * 100) : 100;
      box.querySelector('[data-mh-barc]').style.width = pc + '%';
      box.querySelector('[data-mh-barp]').style.width = (100 - pc) + '%';
      box.querySelector('[data-mh-per]').textContent = fill(tx.tPer, { m: fmt(profit / units) }) + (units >= KIT[prod] ? ' · ' + tx.tKit : '');
      if (go) go.href = go.href.replace(/products\/[^?]+/, prod === 'B30' ? 'products/maligo-aftercare-butter' : 'products/maligo-aftercare-jelly');
    };
    box.querySelectorAll('[data-mh-cprod] button').forEach((b) => b.addEventListener('click', () => {
      prod = b.dataset.v; box.querySelectorAll('[data-mh-cprod] button').forEach((x) => x.classList.toggle('is-on', x === b)); chips(); calc();
    }));
    box.querySelectorAll('[data-mh-step]').forEach((b) => b.addEventListener('click', () => {
      const v = (parseFloat(String(price.value).replace(',', '.')) || 0) + (+b.dataset.mhStep);
      price.value = Math.min(99, Math.max(1, v)); calc();
    }));
    price.addEventListener('input', calc); chips(); calc();
  });

  // 3D-Dose zum Ausprobieren
  const LOGO_DB = { name: 'maligo-logos', store: 'files' };
  function logoDb(version) {
    return new Promise((resolve, reject) => {
      if (!window.indexedDB) return reject(new Error('no idb'));
      const req = version ? indexedDB.open(LOGO_DB.name, version) : indexedDB.open(LOGO_DB.name);
      req.onupgradeneeded = () => { if (!req.result.objectStoreNames.contains(LOGO_DB.store)) req.result.createObjectStore(LOGO_DB.store); };
      req.onsuccess = () => { const db = req.result; if (db.objectStoreNames.contains(LOGO_DB.store)) return resolve(db); const next = db.version + 1; db.close(); logoDb(next).then(resolve, reject); };
      req.onerror = () => reject(req.error);
    });
  }
  async function logoSave(key, file) {
    try { const db = await logoDb(); db.transaction(LOGO_DB.store, 'readwrite').objectStore(LOGO_DB.store).put({ blob: file, name: file.name, type: file.type, ts: Date.now() }, key); } catch (e) {}
  }
  async function logoLoad(key) {
    try { const db = await logoDb(); return await new Promise((res) => { const q = db.transaction(LOGO_DB.store).objectStore(LOGO_DB.store).get(key); q.onsuccess = () => res(q.result && q.result.blob ? new File([q.result.blob], q.result.name, { type: q.result.type }) : null); q.onerror = () => res(null); }); } catch (e) { return null; }
  }
  const toImg = (file) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = URL.createObjectURL(file); });

  document.querySelectorAll('[data-mh-try]').forEach((box) => {
    const stage = box.querySelector('[data-mh-stage]'), go = box.querySelector('[data-mh-go]');
    let viewer = null, type = 'J30', label = 'ORI', img = null;
    const apply = () => {
      if (!viewer) return;
      viewer.setStyle(label);
      ['lid', 'front', 'side'].forEach((s) => viewer.setLogo(s, null));
      if (img) { viewer.setLogo('lid', img); if (type === 'J30') viewer.setLogo('front', img); }
    };
    const updGo = () => {
      go.hidden = !img;
      go.href = box.dataset.r + 'products/' + (type === 'B30' ? 'maligo-aftercare-butter' : 'maligo-aftercare-jelly') + '?konfigurator=1';
      box.querySelector('[data-mh-up]').hidden = !!img; box.querySelector('[data-mh-change]').hidden = !img;
      box.querySelector('[data-mh-bw]').hidden = label === 'ORI';
    };
    const start = async () => {
      try {
        const mod = await import(box.dataset.src);
        viewer = await mod.createViewer(stage, { type, label, placeholder: 'YOUR LOGO' });
        stage.classList.add('is-3d');
        const saved = await logoLoad('lid');
        if (saved && !img) { try { img = await toImg(saved); } catch (e) {} }
        apply(); updGo();
        viewer.setView && viewer.setView('front');
        if (!reduce && viewer.wiggle) setTimeout(() => viewer.wiggle(), 600);
      } catch (e) { /* 3D nicht verfügbar: Foto bleibt stehen */ }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => { if (e.isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '200px' });
      io.observe(box);
    } else start();
    box.querySelectorAll('[data-mh-type] button').forEach((b) => b.addEventListener('click', async () => {
      type = b.dataset.v; box.querySelectorAll('[data-mh-type] button').forEach((x) => x.classList.toggle('is-on', x === b));
      if (viewer) { await viewer.setCan(type); apply(); viewer.setView && viewer.setView('front'); }
      updGo();
    }));
    box.querySelectorAll('[data-mh-label] button').forEach((b) => b.addEventListener('click', () => {
      label = b.dataset.v; box.querySelectorAll('[data-mh-label] button').forEach((x) => x.classList.toggle('is-on', x === b)); apply(); updGo();
    }));
    box.querySelector('[data-mh-file]').addEventListener('change', async (ev) => {
      const f = ev.target.files && ev.target.files[0]; if (!f) return;
      try { img = await toImg(f); } catch (e) { return; }
      logoSave('lid', f); logoSave('front', f);
      apply(); updGo();
      viewer && viewer.setView && viewer.setView('front');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maligo-home2"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__m2Init) return; window.__m2Init = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) document.querySelectorAll('.m2-hero__bg video').forEach((v) => { v.removeAttribute('autoplay'); v.pause(); });

  // Links zu 3D-Test / Rechner auf derselben Seite: hinscrollen statt Seitenwechsel (sonst normaler Link zum Konfigurator)
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-m2-go]'); if (!a) return;
    const el = document.querySelector(a.dataset.m2Go); if (!el) return;
    e.preventDefault(); el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  if (!('IntersectionObserver' in window)) return;
  // feste „Jetzt gestalten“-Leiste am Handy: nach dem Startbild, nicht über dem Abschluss/Fußbereich
  const hero = document.querySelector('[data-m2-hero]'), sticky = document.querySelector('[data-m2-sticky]');
  if (hero && sticky) {
    let past = false, end = false;
    const set = () => sticky.classList.toggle('is-on', past && !end);
    new IntersectionObserver(([e]) => { past = !e.isIntersecting && e.boundingClientRect.top < 0; set(); }).observe(hero);
    const ends = [document.querySelector('[data-m2-final]'), document.querySelector('footer, .shopify-section-group-footer-group')].filter(Boolean);
    const vis = new Set();
    const io = new IntersectionObserver((es) => { es.forEach((x) => x.isIntersecting ? vis.add(x.target) : vis.delete(x.target)); end = vis.size > 0; set(); });
    ends.forEach((el) => io.observe(el));
  }
  // sanftes Einblenden
  if (!reduce) {
    const els = document.querySelectorAll('.m2-state > *, .m2-prod, .m2-tile, .m2-steps li, .m2-wall > *, .m2-card');
    const io2 = new IntersectionObserver((es) => es.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('is-in'); io2.unobserve(x.target); } }), { rootMargin: '0px 0px -6% 0px' });
    els.forEach((el) => { if (el.getBoundingClientRect().top > window.innerHeight) { el.classList.add('m2-fx'); io2.observe(el); } });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
